import { Box, Button, Grid, TextField } from '@mui/material'
import { ErrorDialog, SuccessDialog, SyncDialog } from '../Dialogs'
import React, { useState } from 'react'

function SyncApplStatus({ service }) {
  const [errorMessage, setErrorMessage] = useState('')
  const [procNum, setProcNum] = useState('')
  const [showErrorDialog, setShowErrorDialog] = useState(false)
  const [showDialog, setShowDialog] = useState(false)
  const [showSuccessDialog, setShowSuccessDialog] = useState(false)
  const [successMessage, setSuccessMessage] = useState('')

  const handleSubmit = event => {
    event.preventDefault()
    setShowDialog(true)
  }

  const showError = message => {
    setErrorMessage(message)
    setShowErrorDialog(true)
  }

  const sync = async () => {
    try {
      const result = await service.postSync(procNum)
      if (result.status === 200) {
        setShowSuccessDialog(true)
        setSuccessMessage(`Applicant with proc_num ${result.data.proc_num} synced. Status
        ${result.data.old_proc_status_name} was synced to ${result.data.new_proc_status_name} and Stage 
        ${result.data.old_stage_name} was synced to ${result.data.new_stage_name}`)
      }
    } catch (error) {
      showError(`proc_num status not synced: ${error.response.data}`)
    } finally {
      setShowDialog(false)
    }
  }

  return (
    <div>
      <Box padding={5}>
        <form onSubmit={handleSubmit}>
          <Grid
            container
            direction="column"
            justifyContent="space-around"
            spacing={3}
          >
            <Grid container item spacing={3}>
              <Grid item xs={4}>
                <h2>Sync Applicant Status</h2>
                <p>
									Sometimes, an applicant has a hire record but is stuck in some
									strange status (i.e. <b>&quot;Applied: Onboarding&quot;</b>,{' '}
                  <b>&quot;Released: Terminated&quot;</b>, etc.).
                </p>
                <p>
									We don&apos;t know why this happens, but we can fix it. Get
									the record&apos;s proc_num by examining the elements in
									Manager portal and grabbing the number from the data-id. Enter
									that value here and press Sync.
                </p>
                <TextField
                  id="proc_num"
                  label="proc_num"
                  onChange={e => {
                    setProcNum(e.target.value)
                  }}
                  value={procNum}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  aria-label="sync-button"
                  color="primary"
                  disabled={procNum.length === 0}
                  type="submit"
                  variant="contained"
                >
									Sync
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Box>
      <SyncDialog
        onClose={() => setShowDialog(false)}
        open={showDialog}
        sync={sync}
      />
      <ErrorDialog
        message={errorMessage}
        onClose={() => setShowErrorDialog(false)}
        open={showErrorDialog}
      />
      <SuccessDialog
        message={successMessage}
        onClose={() => setShowSuccessDialog(false)}
        open={showSuccessDialog}
      />
    </div>
  )
}

export default SyncApplStatus
